/**
 * Basic Home Slider
 */
let homeSwiper = new Swiper('.home-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    centeredSlides: true,
    loop: true,
    loopedSlides: 1,
    longSwipes: false,
    allowTouchMove: false,
    keyboard: {
        enabled: false,
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            let tag = document.getElementById('tag-' + (index + 1));
            return '<span class="' + className + '">' + tag.innerHTML + '</span>';
        },
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    }
});

/**
 * Main Swiper
 */
let mainSwiper = new Swiper('.main-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: false,
    centeredSlides: true,
    loop: true,
    loopedSlides: 1,
    longSwipes: false,
    allowTouchMove: true,
    speed: 1500,
    keyboard: {
        enabled: true,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            let tag = document.getElementById('tag-' + (index + 1));
            return '<span class="' + className + '">' + tag.innerHTML + '</span>';
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

/**
 * Product Swiper
 */
let productSwiper = new Swiper('.product-swiper', {
    slidesPerView: 1,
    sliderPerGroup: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: true,
    allowTouchMove: true,
    speed: 1500,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    keyboard: {
        enabled: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    breakpointsInverse: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            sliderPerGroup: 2,
            spaceBetween: 5
        },
        1140: {
            slidesPerView: 3,
            sliderPerGroup: 3,
            spaceBetween: 5
        },
        1440: {
            slidesPerView: 4,
            sliderPerGroup: 4,
            spaceBetween: 5
        }
    },
});
